import React from 'react';

import { BoxBackground, InspirationBoxSvg, InspirationTokenSvg } from '@dndbeyond/character-components/es';
import { CharacterTheme } from '@dndbeyond/character-rules-engine/es';

interface Props {
    inspiration: boolean;
    onToggle?: () => void;
    onClick?: () => void;
    isInteractive: boolean;
    theme: CharacterTheme;
}
export default class Inspiration extends React.PureComponent<Props> {
    handleToggleClick = (evt: React.MouseEvent): void => {
        const { onToggle } = this.props;

        if (onToggle) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onToggle();
        }
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick();
        }
    };

    render() {
        const { inspiration, isInteractive, theme } = this.props;

        let inspirationClasses: Array<string> = ['ct-inspiration__status'];
        if (inspiration) {
            inspirationClasses.push('ct-inspiration__status--active');
        } else {
            inspirationClasses.push('ct-inspiration__status--inactive');
        }

        let boxClasses: Array<string> = ['ct-inspiration__box'];
        if (isInteractive) {
            boxClasses.push('ct-inspiration__box--interactive');
        }

        return (
            <div className="ct-inspiration" onClick={this.handleClick}>
                <div className={boxClasses.join(' ')} onClick={this.handleToggleClick}>
                    <BoxBackground StyleComponent={InspirationBoxSvg} theme={theme} />
                    <div className={inspirationClasses.join(' ')}>
                        {inspiration && <InspirationTokenSvg theme={theme} />}
                    </div>
                </div>
                <div
                    className={`ct-inspiration__label ${theme.isDarkMode ? 'ct-inspiration__label--dark-mode' : ''}`}
                    onClick={this.handleClick}
                >
                    Inspiration
                </div>
            </div>
        );
    }
}
